import {Component, NgZone, OnDestroy, OnInit} from '@angular/core';
import {DjangoApiService} from "../../../../shared/services/django-api.service";
import {ActivatedRoute, Router, RouterOutlet} from "@angular/router";
import {Observable, Subscription} from "rxjs";
import {PlotlyModule, PlotlySharedModule} from "angular-plotly.js";
import * as Plotly from 'plotly.js-dist-min';
import {CardsBasicComponent} from "../../../../shared/components/cards/cards-basic/cards-basic.component";
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";
import {LanguageService} from "../../../../shared/services/language.service";
import {LangChangeEvent, TranslateModule, TranslateService} from "@ngx-translate/core";
import {CommonModule} from "@angular/common";
import {SectionListComponent} from "../../../sections/public/section-list/section-list.component";
import {MatChip, MatChipListbox, MatChipOption, MatChipSet} from "@angular/material/chips";
import {MatTooltip} from "@angular/material/tooltip";
import {MatButton} from "@angular/material/button";
import {PageListComponent} from "../../../pages/public/page-list/page-list.component";

PlotlyModule.plotlyjs = Plotly;

@Component({
  selector: 'app-product-detail',
  standalone: true,
  imports: [
    CommonModule,
    PlotlySharedModule,
    PlotlyModule,
    CardsBasicComponent,
    MatProgressSpinnerModule,
    SectionListComponent,
    MatChip,
    MatChipSet,
    MatTooltip,
    TranslateModule,
    MatChipListbox,
    MatChipOption,
    MatButton,
    PageListComponent,
    RouterOutlet
  ],
  templateUrl: './product-detail.component.html',
  styleUrls: ['./product-detail.component.css']
})
export class ProductDetailComponent implements OnInit, OnDestroy {
  productSlug!: any;
  productData!: any;
  currentLanguage!: string;
  langChangeSubscription: Subscription | null = null;
  private subscriptions: Subscription = new Subscription();

  constructor(
    private _apiService: DjangoApiService,
    private _route: ActivatedRoute,
    private _languageService: LanguageService,
    private _translate: TranslateService) {
  }

  ngOnInit(): void {
    this.setupLanguageSubscription()
    this.subscribeToRouteParams();
  }

  private setupLanguageSubscription(): void {
    this.currentLanguage = this._languageService.getLanguage();
    this.subscriptions.add(
      this.langChangeSubscription = this._translate.onLangChange.subscribe((event: LangChangeEvent) => {
        this.currentLanguage = event.lang;
      })
    );
  }

  private subscribeToRouteParams(): void {
    this.subscriptions.add(
      this._route.paramMap.subscribe(params => {
        this.productSlug = params.get('productSlug');
        this.loadProductData();
      })
    );
  }

  private loadProductData(): void {
    this.subscriptions.add(
      this._apiService.fetchProductDetail(this.productSlug).subscribe({
        next: (response: any) => {
          this.productData = response;
        },
        error: (error: any) => {
          console.error('There was an error fetching the user information', error);
        }
      })
    );
  }


  ngOnDestroy():void {
    this.subscriptions.unsubscribe();
  }
}
